var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolGeoIcVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 43.8412L52.5 41.9662V37.5C52.4954 34.8439 51.552 32.2749 49.8364 30.2471C48.1209 28.2193 45.7437 26.8633 43.125 26.4188V22.5H39.375V26.4188C36.7563 26.8633 34.3791 28.2193 32.6636 30.2471C30.948 32.2749 30.0046 34.8439 30 37.5V41.9662L26.25 43.8412V52.5H37.5V56.25H45V52.5H56.25V43.8412ZM52.5 48.75H30V46.1588L33.75 44.2838V37.5C33.75 35.5109 34.5402 33.6032 35.9467 32.1967C37.3532 30.7902 39.2609 30 41.25 30C43.2391 30 45.1468 30.7902 46.5533 32.1967C47.9598 33.6032 48.75 35.5109 48.75 37.5V44.2838L52.5 46.1588V48.75Z",
    fill: "#FFB629"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 11.25C52.5 10.2554 52.1049 9.30161 51.4016 8.59835C50.6984 7.89509 49.7446 7.5 48.75 7.5H41.25V3.75H37.5V7.5H22.5V3.75H18.75V7.5H11.25C10.2554 7.5 9.30161 7.89509 8.59835 8.59835C7.89509 9.30161 7.5 10.2554 7.5 11.25V48.75C7.5 49.7446 7.89509 50.6984 8.59835 51.4016C9.30161 52.1049 10.2554 52.5 11.25 52.5H18.75V48.75H11.25V11.25H18.75V15H22.5V11.25H37.5V15H41.25V11.25H48.75V22.5H52.5V11.25Z",
    fill: "#FFB629"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolGeoIcVisibility);
export default __webpack_public_path__ + "static/media/sol-geo-ic-visibility.378e32e2667ffcc7bc5620548acc188f.svg";
export { ForwardRef as ReactComponent };